import React from "react";
import {css} from "@emotion/css";

const RaikoBaseContainer = ({children, className}) => {
    return (
        <div className={
            `${
                css`padding: 26px 0;
                  overflow: hidden`
            } 
            ${className}`
        }>
            {children}
        </div>
    )
}

export default RaikoBaseContainer